module.exports = __webpack_public_path__ + "static/03-662ab2ee295ff7d926a2c90475ac193a.png";